<template>
  <admin-page-shell :title="$t('frontend_groovemail_admin_blocklists')">
    <template slot="tabs">
      <gd-tabs
        :tabs="tabs"
        :currentTab="currentTab"
        @onClick="handleTabChange"
      />
    </template>
    <component :is="currentTab" />
  </admin-page-shell>
</template>

<script>
import BlockEmails from './block-emails';
import BlockToDomains from './block-to-domains';
import BlockFromDomains from './block-from-domains';
import BlockDomainsInEmails from './block-domain-in-emails';
import HardBounces from './hard_bounces';
import SpamBounces from './spam_bounces';
import AdminPageShell from '../AdminPageShell.vue';

export default {
  middleware: 'auth',
  metaInfo() {
    return { title: this.$t('frontend_groovemail_admin_blocklists') };
  },
  data() {
    return {
      currentTab: 'blockEmails',
    };
  },
  components: {
    AdminPageShell,
    blockEmails: BlockEmails,
    blockToDomains: BlockToDomains,
    blockFromDomains: BlockFromDomains,
    blockDomainsInEmails: BlockDomainsInEmails,
    hardBouncesEmails: HardBounces,
    spamBouncesEmails: SpamBounces,
  },
  methods: {
    /**
     * Used to handle tab change based on block lists type.
     * @param {string} newTab changed tab.
     */
    handleTabChange(newTab) {
      this.currentTab = newTab;
    },
  },

  computed: {
    /**
     * Returns block lists tab data.
     * @return {array} - array of block lists.
     */
    tabs() {
      return [
        {
          title: `<span class="text-sm font-semibold px-4">${this.$t(
            'frontend_groovemail_admin_block_emails'
          )}</span>`,
          value: 'blockEmails',
        },
        {
          title: `<span class="text-sm font-semibold px-4">${this.$t(
            'frontend_groovemail_admin_block_to_domains'
          )}</span>`,
          value: 'blockToDomains',
        },
        {
          title: `<span class="text-sm font-semibold px-4">${this.$t(
            'frontend_groovemail_admin_block_from_domains'
          )}</span>`,
          value: 'blockFromDomains',
        },
        {
          title: `<span class="text-sm font-semibold px-4">${this.$t(
            'frontend_groovemail_block_domains_email_content_title'
          )}</span>`,
          value: 'blockDomainsInEmails',
        },
        {
          title: `<span class="text-sm font-semibold px-4">${this.$t(
            'frontend_groovemail_admin_hard_bounce_emails'
          )}</span>`,
          value: 'hardBouncesEmails',
        },
        {
          title: `<span class="text-sm font-semibold px-4">${this.$t(
            'frontend_groovemail_admin_spam_bounce_emails'
          )}</span>`,
          value: 'spamBouncesEmails',
        },
      ];
    },

    /**
     * Returns class for block lists tab.
     * @return {string} - class for block lists tab.
     */
    mainTabClass() {
        return 'pb-4 gs-default-tabs-item';
    },
  },
};
</script>

